export default __webpack_public_path__ + "static/media/meals_card_2@3x.fed2858e.png";